import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Props {
  totalSkus: number;
  totalValue: number;
  totalReserved: number;
  belowReorder: number;
}

export default function StockSummaryCards({ totalSkus, totalValue, totalReserved, belowReorder }: Props) {
  const cards = [
    {
      id: 'sc-skus',
      label: 'Total SKUs',
      value: totalSkus.toString(),
      icon: 'CubeIcon',
      iconBg: 'bg-secondary/10 text-secondary',
      sub: 'Across all sites',
    },
    {
      id: 'sc-value',
      label: 'On-Hand Value',
      value: `€ ${totalValue.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
      icon: 'BanknotesIcon',
      iconBg: 'bg-teal/10 text-teal',
      sub: 'Weighted avg cost basis',
    },
    {
      id: 'sc-reserved',
      label: 'Total Reserved Qty',
      value: totalReserved.toLocaleString('de-DE'),
      icon: 'LockClosedIcon',
      iconBg: 'bg-amber-50 text-amber-600',
      sub: 'Committed to open GIs',
    },
    {
      id: 'sc-reorder',
      label: 'Below Reorder Level',
      value: belowReorder.toString(),
      icon: 'ExclamationTriangleIcon',
      iconBg: 'bg-red-50 text-red-600',
      sub: belowReorder > 0 ? 'Immediate action required' : 'All stock healthy',
      alert: belowReorder > 0,
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.id}
          className={`bg-card border rounded-xl p-5 shadow-card ${card.alert ? 'border-red-200 bg-red-50/40' : 'border-border'}`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${card.iconBg}`}>
              <Icon name={card.icon as Parameters<typeof Icon>[0]['name']} size={18} />
            </div>
          </div>
          <p className="text-[11px] font-500 uppercase tracking-widest text-muted-foreground">{card.label}</p>
          <p className="text-2xl font-700 text-foreground tabular-nums mt-1">{card.value}</p>
          <p className={`text-xs mt-1 ${card.alert ? 'text-red-600 font-500' : 'text-muted-foreground'}`}>{card.sub}</p>
        </div>
      ))}
    </div>
  );
}